import { render } from "./ThePromocodeListItem.vue?vue&type=template&id=29d7124e&scoped=true&ts=true&lang=html"
import script from "./ThePromocodeListItem.vue?vue&type=script&lang=ts"
export * from "./ThePromocodeListItem.vue?vue&type=script&lang=ts"

import "./ThePromocodeListItem.vue?vue&type=style&index=0&id=29d7124e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d7124e"]])

export default __exports__